import { Reveal } from "@/lib/reveal";
import { useLang } from "@/lib/lang";

export default function BookSection() {
  const { t } = useLang();
  const b = t.book;
  const frameClass = b.mockup ? "frame book-mockup" : "frame p23";

  return (
    <section className="pad alt section-line" id="book" data-testid="book-section">
      <div className="two-col even">
        <Reveal className={frameClass} data-testid="book-image">
          <img src={b.image} alt={b.title} loading="lazy" />
        </Reveal>
        <div>
          <Reveal className="eyebrow">{b.eyebrow}</Reveal>
          <Reveal delay={0.05}>
            <h2 className="mid" data-testid="book-title">{b.title}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="body" style={{ marginBottom: 36 }}>{b.body}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="cta-row">
              <a href={b.buyLink} target="_blank" rel="noopener noreferrer" className="btn" data-testid="book-purchase-btn">
                {b.button}
              </a>
              {b.buyLink2 && (
                <a href={b.buyLink2} target="_blank" rel="noopener noreferrer" className="btn-outline" data-testid="book-purchase-btn-2">
                  {b.button2}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
